




































import axios from 'axios';
import QRCode from 'qrcode';
import Vue from 'vue';
import { Utils } from '../../Utils';
export default Vue.extend({
    data: function() {
        return {
            qr: '',
            campaignImage: '',
        };
    },
    props: {
        campaign: String,
    },
    created: async function() {

        this.qr = await QRCode.toDataURL(
            `${window.location.origin}/${this.campaign}${location.search}${location.hash}`,
            {
                margin: 0,
                // scale: 48,
                width: 768,
            }
        );

        var res = await axios
            .get(
                `${process.env.VUE_APP_API_URI}/api/admin/weblink/${this.campaign}/image`,
                {
                    responseType: 'blob',
                }
            )
            .then(res => res.data)
            .catch(err => {
                console.log('No custom image found');
            });

        if (res) {
            var url = URL.createObjectURL(res);

            this.campaignImage = url;
        } else {
            this.campaignImage = require('../../assets/UFCW_Logo.png');
        }
    },
});
